import { render } from "./tracking-task-footer.vue?vue&type=template&id=e6e1c106&scoped=true"
import script from "./tracking-task-footer.vue?vue&type=script&lang=js"
export * from "./tracking-task-footer.vue?vue&type=script&lang=js"

import "./tracking-task-footer.vue?vue&type=style&index=0&id=e6e1c106&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/praxisti/htdocs/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6e1c106"]])

export default __exports__